import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year6/Spring/Algebra/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Algebra',
  field: 'Number',
  weeks: [3, 4],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Algebra/1Num1StepFunctionMachines" */ './1Num1StepFunctionMachines'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Algebra/2Num2StepFunctionMachines" */ './2Num2StepFunctionMachines'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Algebra/3FormExpressions" */ './3FormExpressions')
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Algebra/4Substitution" */ './4Substitution')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () => import(/* webpackChunkName: "Year6/Spring/Algebra/5Formulae" */ './5Formulae')
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(/* webpackChunkName: "Year6/Spring/Algebra/6FormEquations" */ './6FormEquations')
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Algebra/7Solve1StepEquations" */ './7Solve1StepEquations'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Algebra/8Solve2StepEquations" */ './8Solve2StepEquations'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Algebra/9FindPairsOfValues" */ './9FindPairsOfValues'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year6/Spring/Algebra/10SolveProblemsWithTwoUnknowns" */ './10SolveProblemsWithTwoUnknowns'
        )
    })
  ]
});
export default Block;
